import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import Vuex from "vuex";
import facture from "./store/ged/facture";
import user from "./store/user";
import general from "./store/core/general";
import bordereau from "./store/ged/bordereau";
import dr from "./store/core/dr";
import structure from "./store/core/structure";
import contrat from "./store/ged/contrat";
import tier from "./store/ged/tier";
import marche from "./store/ged/marche";
import commande from "./store/ged/commande";
import od from "./store/ged/od";
import mission from "./store/ged/mission";
import fichiers from "./store/ged/fichiers";
import autreDocumentComptable from "./store/ged/autreDocumentComptable";
import autreDocDescription from "./store/ged/autreDocDescription";

Vue.config.productionTip = false;
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    facture,
    dr,
    structure,
    user,
    general,
    bordereau,
    contrat,
    tier,
    marche,
    commande,
    od,
    mission,
    fichiers,
    autreDocumentComptable,
    autreDocDescription,
  },
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
